import { IsNotEmpty, IsUUID } from 'class-validator';

export class PriceListUpdateRequest {
    @IsUUID()
    @IsNotEmpty()
    public priceTypeUuid!: string;

    @IsNotEmpty()
    public priceTypeName!: string;

    constructor(data?: Partial<PriceListUpdateRequest>) {
        this.priceTypeUuid = data?.priceTypeUuid || '';
        this.priceTypeName = data?.priceTypeName || '';
    }
}

